import { gEnums } from 'global/enums/globalEnums';
import { _profileCollectionName } from 'global/firestoreData/profiles/getProfile';
import { getTempSettingsState } from 'global/firestoreData/settings/ammendSettings';
import { vsComponentTypes } from 'global/viewSettings/enums/vsComponentTypes';
import _ from 'lodash';
import { useMemo } from 'react';

export const useSettingsMenuProps = ({ swipedItem, swipedItems, vit, isGlobal, settings_temp, settings_temp_global }) => {

  const { updateProps, data_current, buttonPermissions } = useMemo(() => {

    const { key, parentSettingKey, parentKey, subKey, dataListType, attachToParent } = swipedItem ?? {}

    const _updateProps = {
      attachToParent: attachToParent,
      dataListType: dataListType,
      diKey: null,
      dKey: null,
      formKey: key,
      parentKey,
      parentSettingKey,
      pit: null,
      psg: null,
      subKey,
      vit: null,
      consoleItemType: gEnums.consoleItemTypes.vw
    }

    // see if any of the parents have specific values
    const vitSwipeItem = _.find(swipedItems, 'vit')
    const pitSwipeItem = _.find(swipedItems, 'pit')
    const psgSwipeItem = _.find(swipedItems, 'psg')
    const ditSwipeItem = _.find(swipedItems, 'dKey')
    const ditiSwipeItem = _.find(swipedItems, 'diKey')

    if (vit) {
      // updateProps.vit = vit
    } else {
      if (swipedItem.vit) {
        _updateProps.vit = swipedItem.vit
      } else if (vitSwipeItem) {
        _updateProps.vit = vitSwipeItem.vit
      }
    }

    if (swipedItem.pit) {
      _updateProps.pit = swipedItem.pit
    } else if (pitSwipeItem) {
      _updateProps.pit = pitSwipeItem.pit
    }

    if (swipedItem.psg) {
      _updateProps.psg = swipedItem.psg
    } else if (psgSwipeItem) {
      _updateProps.psg = psgSwipeItem.psg
    }

    if (swipedItem.dKey) {
      _updateProps.dKey = swipedItem.dKey
    } else if (ditSwipeItem) {
      _updateProps.dKey = ditSwipeItem.dKey
    }

    if (swipedItem.diKey) {
      _updateProps.diKey = swipedItem.diKey
    } else if (ditiSwipeItem) {
      _updateProps.diKey = ditiSwipeItem.diKey
    }

    if (swipedItem.pit) {
      _updateProps.consoleItemType = gEnums.consoleItemTypes.pr
    } else if (swipedItem.vit) {
      _updateProps.consoleItemType = gEnums.consoleItemTypes.vi
    }

    // const allSwipeItems = [...swipedItems, swipedItem]
    const _data_current = getCurrentData(settings_temp, swipedItems, settings_temp_global, isGlobal)
    const _buttonPermissions = getButtonPermissions(swipedItem, swipedItems, isGlobal)


    return { updateProps: _updateProps, data_current: _data_current, buttonPermissions: _buttonPermissions }
  }, [swipedItem])

  return { updateProps, data_current, buttonPermissions }

};

/** Returns the curren data of the last swiped item */
const getCurrentData = (settings_temp, swipedItems, settings_globalPageItems, isGlobal) => {

  let cd;

  const aps = []

  // settings_page
  const { _global, _viewItems } = getTempSettingsState(settings_temp, isGlobal)
  const isGv = swipedItems && swipedItems[0] && swipedItems[0].key === 'settings_globalPageItems' ? true : false
  let gvv = null;

  // settings_globalPageItems need wrapped because it does not have a parent object.
  if (isGv) { gvv = settings_globalPageItems }

  if (swipedItems && swipedItems.length > 0) {
    Object.keys(swipedItems).forEach(key => {
      const swipeItem = swipedItems[trueKey(key)]
      const { key: swipeKey, subKey } = swipeItem
      const dk = subKey ? subKey : swipeKey
      aps.push(dk)
    })
  }

  // remove prop if under propSections
  if (aps.includes('props') && aps.includes('propSections')) {
    const propsIndex = aps.indexOf('props');
    aps.splice(propsIndex, 1);
  }

  if (aps.length > 0) {
    aps.forEach(dk => {
      const _tk = trueKey(dk)
      if (cd) {
        // existnging data
        cd = cd[_tk]
      } else {
        // initial data
        if (isGv && gvv) {
          cd = gvv[_tk]
        } else {
          cd = _global
          cd = cd ? cd[_tk] : null
          // LOOOK
          if (_.isArray(cd)) { cd = {} }
          if (!cd && _viewItems) {
            cd = _viewItems[_tk]
          }
        }
      }
    })
  }

  return cd ? cd : {}

}

const trueKey = (key) => {
  switch (key) {
    case 'settings_globalPageItems':
    case 'views':
      return 'viewItems'
    default:
      return key
  }
}

const getButtonPermissions = (swipedItem, _swipedItems, isGlobal) => {

  const sortAllows = ['props', 'propSections', 'viewItems', 'views']
  const arrangeAllows = ['props', 'views']

  const { key, subKey, isList } = swipedItem

  // const xxx = isGlobal ? saSplits.global.global : saSplits.page.page

  // let allowHomeSettings = appUserAccess.isSuperAdmin && xxx && xxx[key] ? true : false
  // let allowHelp = xxx && xxx[key] ? true : false

  const buttonPermissions = {
    allowAdd: allowAdd(key, subKey, isList),
    allowAdds: allowAdd(key, subKey, isList),
    allowAddSection: allowSection(key, subKey, isList),
    allowManageSection: allowSection(key, subKey, isList),
    allowArrange: arrangeAllows.includes(key) ? true : false,
    allowAuth: key === _profileCollectionName ? true : false,
    allowFavorite: isGlobal && _swipedItems.length < 2 ? true : false,
    allowFiles: key === 'files' ? true : false,
    // allowHelp: allowHelp,
    allowNotification: key === 'notifications' ? true : false,
    allowSort: sortAllows.includes(key) ? true : false,
    allowSortOk: key === 'sort' ? true : false,
    // allowHomeSettings: allowHomeSettings,
    allowModifyPropData: key === 'data' ? true : false,
    allowReorder: !isGlobal && key === 'data' ? true : false,
  }
  return buttonPermissions
}

const allowAdd = (key, _subKey, isList) => {
  if (isList) {
    return true
  } else {
    switch (key) {
      case vsComponentTypes.globalPageItems:
      case vsComponentTypes.notificationsManager:
      case vsComponentTypes.props:
      case vsComponentTypes.rssFeeds:
      case vsComponentTypes.viewItems:
      case vsComponentTypes.views:
        return true;
      default:
        // nothing
        return false
    }
  }
}

const allowSection = (key, _subKey, isList) => {
  if (isList) {
    return true
  } else {
    switch (key) {
      case vsComponentTypes.props:
        return true;
      default:
        return false
    }
  }
}